module.exports = __webpack_public_path__ + "static/assets/0fbf0f28b13c0f6395c23facb7c7bb34.ttf";